

































import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import Mixin from '../mixin';

@Component
export default class NewOrganization extends Mixin {
  private id: string = '';
  private name: string = '';
  private admin: string = '';
  private email: string = '';

  @Mutation private organizationAdd!: (org: any) => void;

  private mounted() {
    (this.$el.querySelector('#id') as HTMLInputElement).focus();
  }

  private async upload(event: any) {
    event.stopPropagation();
    if (this.id.length < 1) {
      this.msg('団体IDを入力してください');
      (this.$el.querySelector('#id') as HTMLInputElement).focus();
      return;
    }
    if (document.querySelector('#id:invalid')) {
      this.msg('団体IDの形式が正しくありません。メールアドレスに使える形式にしてください');
      (this.$el.querySelector('#id') as HTMLInputElement).focus();
      return;
    }
    if (this.name.length < 1) {
      this.msg('団体名を入力してください');
      (this.$el.querySelector('#name') as HTMLInputElement).focus();
      return;
    }
    if (this.admin.length < 1) {
      this.msg('管理者ユーザーIDを入力してください');
      (this.$el.querySelector('#admin') as HTMLInputElement).focus();
      return;
    }
    if (this.email.length < 1) {
      this.msg('管理者メールアドレスを入力してください');
      (this.$el.querySelector('#email') as HTMLInputElement).focus();
      return;
    }
    if (document.querySelector('#email:invalid')) {
      this.confirm('メールアドレスの形式が正しくないようです。処理を続行しますか?', () => this.post(event));
    } else {
      await this.post(event);
    }
  }

  private async post(event: any) {
    try {
      event.target.disabled = true;

      this.organizationAdd(await API.post('api', '/organization/new', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body: {ID: this.id, User: this.admin, Email: this.email, Org: this.name},
      }));
      this.msg('団体を作成しました');
      this.$router.push('/organization');
    } catch (ex) {
      if (ex.response && ex.response.status === 409) {
        this.msg('IDまたは名称が他の団体と重複しています');
        (this.$el.querySelector('#id') as HTMLInputElement).focus();
        return;
      }
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }
}

